import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Mail, Facebook, Send } from 'lucide-react';
import { BRAND } from '../constants/brand';

const Footer = () => {
  const year = new Date().getFullYear();

  const exploreLinks = [
    { to: '/',             label: 'Trang chủ' },
    { to: '/gioi-thieu',   label: 'Về chúng tôi' },
    { to: '/how-it-works', label: 'Cách hoạt động' },
    { to: '/categories',   label: 'Danh mục' },
    { to: '/blog',         label: 'Blog' },
  ];

  const supportLinks = [
    { to: '/faq',              label: 'FAQ' },
    { to: '/terms-of-service', label: 'Điều khoản' },
    { to: '/privacy-policy',   label: 'Bảo mật' },
    { to: '/contact',          label: 'Gửi liên hệ' },
  ];

  const socials = [
    { Icon: Facebook, href: BRAND.facebook, label: 'Facebook' },
    { Icon: Send,     href: BRAND.telegram, label: 'Telegram' },
  ];

  return (
    <footer className="bg-white border-t border-gray-100 mt-16">
      <div className="max-w-7xl mx-auto px-4">

        {/* Brand — full width on mobile, left column on desktop */}
        <div className="pt-8 pb-6 sm:pb-0 sm:pt-8 grid grid-cols-1 sm:grid-cols-4 gap-6 sm:gap-8">
          <div className="space-y-3 sm:pr-2">
            <Link to="/" className="inline-flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center shadow-sm">
                <Shield className="h-4 w-4 text-white" />
              </div>
              <span className="text-base font-bold bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent">
                Trunggian247
              </span>
            </Link>
            <p className="text-xs text-gray-600 leading-relaxed max-w-sm">
              Nền tảng ký quỹ trực tuyến tại Việt Nam. Bảo vệ người mua và người bán trong giao dịch online.
            </p>
          </div>

          {/* 3 equal columns: Khám phá · Hỗ trợ · Liên hệ */}
          <div className="grid grid-cols-3 gap-3 sm:contents">
            <div>
              <h3 className="text-[11px] sm:text-xs font-semibold text-gray-800 uppercase tracking-wider mb-2.5 sm:mb-3">
                Khám phá
              </h3>
              <ul className="space-y-2">
                {exploreLinks.map(({ to, label }) => (
                  <li key={to}>
                    <Link
                      to={to}
                      onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
                      className="text-[11px] sm:text-xs text-gray-600 hover:text-blue-600 transition-colors leading-snug"
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-[11px] sm:text-xs font-semibold text-gray-800 uppercase tracking-wider mb-2.5 sm:mb-3">
                Hỗ trợ
              </h3>
              <ul className="space-y-2">
                {supportLinks.map(({ to, label }) => (
                  <li key={to}>
                    <Link
                      to={to}
                      onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
                      className="text-[11px] sm:text-xs text-gray-600 hover:text-blue-600 transition-colors leading-snug"
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-[11px] sm:text-xs font-semibold text-gray-800 uppercase tracking-wider mb-2.5 sm:mb-3">
                Liên hệ
              </h3>
              <ul className="space-y-2.5">
                <li>
                  <a
                    href={`mailto:${BRAND.email}`}
                    className="inline-flex items-center gap-1.5 text-[11px] sm:text-xs text-gray-600 hover:text-blue-600 transition-colors"
                    title={BRAND.email}
                  >
                    <Mail className="h-3.5 w-3.5 text-blue-600 flex-shrink-0" />
                    <span className="leading-snug break-all">{BRAND.email}</span>
                  </a>
                </li>
                {socials.map(({ Icon, href, label }) => (
                  <li key={label}>
                    <a
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1.5 text-[11px] sm:text-xs text-gray-600 hover:text-blue-600 transition-colors"
                    >
                      <Icon className="h-3.5 w-3.5 flex-shrink-0" />
                      <span>{label}</span>
                    </a>
                  </li>
                ))}
              </ul>
              <p className="hidden sm:block text-xs text-gray-600 mt-3 leading-relaxed">
                Thương hiệu Trunggian247.
              </p>
            </div>
          </div>
        </div>

        <div className="py-4 border-t border-gray-100 mt-6 sm:mt-8">
          <p className="text-[11px] sm:text-xs text-gray-600 text-center">
            © {year} Trunggian247. Bảo lưu mọi quyền.
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
